// web-v2/src/services/producer-shares.service.js
//
// The producers' stated shares and the default producer (deals-door-1 answers round 3, R2c-Q1 and R2c-Q4). The server is the
// gate on every write (the owner's own Google sign-in); these only send the fields. A share is a fraction 0 to 1 on the wire
// and a percent on the page; null is "share not stated" (never 100% assumed). Relative imports so a node test can load it.

import { api } from '../lib/api.js';

export const PRODUCER_SHARES_PATH = '/api/tracon/admin/producer-shares';
export const DEFAULT_PRODUCER_PATH = '/api/tracon/admin/default-producer';

const EXPECTED = [
  { status: 400, code: 'bad_request' }, { status: 403, code: 'owner_only' }, { status: 409, code: 'producer_not_assignable' },
  { status: 401, code: 'broker_email_required' },
];

export function getProducerShares() {
  return api.get(PRODUCER_SHARES_PATH, { expected: [{ status: 403, code: 'owner_only' }] });
}

// body { new_business_share?, renewal_share?, reason? }: only the keys sent change.
export function setProducerShares(userId, body) {
  return api.put(`${PRODUCER_SHARES_PATH}/${encodeURIComponent(userId)}`, body, { expected: EXPECTED });
}

export function setDefaultProducer(userId, reason) {
  return api.put(DEFAULT_PRODUCER_PATH, { user_id: userId, reason: reason || null }, { expected: EXPECTED });
}

export { percentToShare, shareToPercent, shareWords } from '../lib/producer-share.js';
